import { render } from "./WCClearCartModal.vue?vue&type=template&id=a1dfe918"
import script from "./WCClearCartModal.vue?vue&type=script&lang=js"
export * from "./WCClearCartModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__